import * as yup from 'yup'
import { isDate, parse } from 'date-fns'
import { getAcceptedAges } from '../components/Questions/PersonalDetailsQuestion/acceptedAges'
import BaseValidator from './BaseValidator'
import { ApplicationFormAnswers } from '../components/ApplicationForm/ApplicationFormContext'
import { AttributionDetails } from '../components/ApplicationForm/types'

const PersonalDetailsValidator = ({ source }: Partial<AttributionDetails> = {}): BaseValidator => {
  const dateNow = new Date()
  const maxAgeNumber = getAcceptedAges(source)
  const maxYear = new Date(dateNow.setFullYear(dateNow.getFullYear() - maxAgeNumber))
  const minYear = new Date('01/01/1901')

  const parseDateString = (originalValue: string): string | Date => (
    isDate(originalValue)
      ? originalValue
      : parse(originalValue, 'dd-MM-yyyy', new Date())
  )

  const schema = yup.object().shape({
    firstName: yup.string()
      .max(50)
      .label('First name')
      .required('Please enter your first name'),
    surname: yup.string()
      .max(50)
      .label('Surname')
      .required('Please enter your surname'),
    dateOfBirth: yup.date()
      .required()
      .transform((_currentValue, originalValue) => parseDateString(originalValue))
      .typeError('Please enter your date of birth (DD/MM/YYYY)')
      .min(minYear, 'Please enter a year greater than 1900')
      .max(maxYear, `You must be over ${maxAgeNumber} years old to apply`)
  })

  return {
    getValidator: () => schema,
    validateState: ({ personalDetails }: ApplicationFormAnswers) => {
      const dob = personalDetails?.dateOfBirth

      return schema.isValidSync({
        firstName: personalDetails?.firstName,
        surname: personalDetails?.surname,
        dateOfBirth: dob ? `${dob.day}-${dob.month}-${dob.year}` : ''
      })
    }
  }
}

export default PersonalDetailsValidator
